import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'reactstrap';

import { searchClients } from '../helpers/clientAutocomplete';

const styles = {
    autocompleteBox: {
        position: 'absolute', top: '100%', left: 0, zIndex: 50, minWidth: 260,
        backgroundColor: '#FFFFFF', border: '1px solid #E6EDF5', borderRadius: 6,
        boxShadow: '0 10px 20px rgba(0,0,0,0.12)', marginTop: 4, maxHeight: 260, overflowY: 'auto',
    },
    autocompleteItem: { padding: '8px 12px', fontSize: 13, cursor: 'pointer', color: '#3A3F56' },
    chip: {
        display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 10px',
        borderRadius: 16, backgroundColor: '#E6EDF5', fontSize: 13, color: '#3A3F56',
    },
    chipClose: { border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 14, color: '#818FA5', lineHeight: 1 },
};

/**
* Client search box used by the "Client" filter on both the external API
* analytics page and the logs page (VD-725). Reuses the clients list endpoint,
* there is no dedicated autocomplete route.
*/
function ClientAutocompleteInput({ lang, value, label, onSelect, onClear }) {
    let [text, setText] = useState('');
    let [results, setResults] = useState([]);
    let [open, setOpen] = useState(false);
    let timer = useRef(null);

    useEffect(() => {
        if (!text.trim()) {
            setResults([]);
            return;
        }

        if (timer.current) clearTimeout(timer.current);

        timer.current = setTimeout(() => {
            searchClients(text.trim()).then((items) => {
                setResults(items);
                setOpen(true);
            });
        }, 300);

        return () => { if (timer.current) clearTimeout(timer.current); };
    }, [text]);

    if (value) {
        return (
            <div style={styles.chip}>
                {label || value}
                <button type="button" style={styles.chipClose} onClick={onClear} aria-label={'Clear'.translate(lang)}>&times;</button>
            </div>
        );
    }

    return (
        <div style={{ position: 'relative' }}>
            <Input
                type="text"
                style={{ minWidth: 180, height: 42 }}
                placeholder={'Search client...'.translate(lang)}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onFocus={() => results.length && setOpen(true)}
                onBlur={() => setTimeout(() => setOpen(false), 150)}
            />
            {open && results.length ? (
                <div style={styles.autocompleteBox}>
                    {results.map((item) => (
                        <div
                            key={item._id}
                            style={styles.autocompleteItem}
                            onMouseDown={() => {
                                onSelect(item);
                                setText('');
                                setResults([]);
                                setOpen(false);
                            }}
                        >
                            {item.username}{item.customerNumber ? ` (${item.customerNumber})` : ''}
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
}

export { styles as autocompleteStyles };
export default ClientAutocompleteInput;
